import addStartupScript from 'mex_components/app/scripts/events/addStartupScript';

function setupTagListeners() {
  const tagDescriptions = document.querySelectorAll('.curation-tag-description');

  document.addEventListener('click', (event) => {
    const target = event.target;
    // Unhide description associated with collection tag
    if(target.classList.contains('curation-tag')) {
      tagDescriptions.forEach(el => (el.classList.toggle('hidden', el.id !== target.id)));
    }
  });
}

addStartupScript(() => {
  setupTagListeners();
});
